


















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'

@Component
export default class ComponentModalAddProfissionais extends Vue {
  addprfLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get addProfissionaisLoading() {
    return this.addprfLoading
  }

  set addProfissionaisLoading(value: boolean) {
    this.addprfLoading = value
  }

  get selected() {
    return this.getBackofficeContratosStore.selectedProfissionais
  }

  set selected(value: any[]) {
    this.getBackofficeContratosStore.setSelectedProfissionais(value)
  }

  get profissionaisSearch() {
    return this.getBackofficeContratosStore.profissionaisSearch
  }

  set profissionaisSearch(value: string) {
    this.getBackofficeContratosStore.setProfissionaisSearch(value)
  }

  get addProfissionaisList() {
    return this.getBackofficeContratosStore.modal.addProfissionaisList
  }

  get profissionaisTableHeader() {
    return this.getBackofficeContratosStore.profissionaisTableHeader
  }

  get profissionaisExecutantes() {
    return this.getBackofficeContratosStore.profissionaisExecutantes
  }

  formatCPFOnly(c: string) {
    if (!c) return ''
    return `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  closeModalProfissionais() {
    this.getBackofficeContratosStore.clearProfissionaisSearch()
    this.getBackofficeContratosStore.clearSelectedProfissionais()
    this.getBackofficeContratosStore.clearProfissionaisExecutantes()
    this.getBackofficeContratosStore.setShowModalAddProfissionaisList(false)
  }

  async addProfissionais() {
    this.addProfissionaisLoading = true
    await this.getBackofficeContratosStore.addProfissionais()
    this.addProfissionaisLoading = false
    this.closeModalProfissionais()
  }
}
